module.exports = __webpack_public_path__ + "img/pay-bg.8cdcb549.png";